module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-137.fbacce0a.jpg";